import Toast from 'components/ui/Toast.vue';
import ENV from 'config/env';

window.addEventListener('unhandledrejection', (event) => {
    // Prevent error output on the console:
    event.preventDefault();

    // Do not log to console for these environments.
    if (['production', 'staging'].includes(ENV.APP_ENV)) {
        return;
    }

    if (event?.reason?.name === 'JdsError' && event?.reason?.type === 'cancel') {
        return;
    }

    /* eslint-disable no-console */
    if (event.reason && event.reason.name) {
        console.group('Uncaught Rejection:', event.reason.name);
        if (event.reason.message) {
            console.warn(event.reason.message);
        }
        console.warn(event.reason.stack);
        return console.groupEnd();
    }

    console.warn('Uncaught Rejection:', event);
    /* eslint-enable no-console */
});

export class Notifier {
    constructor() {
        this.components = [];
        this.containers = [];
        this.vm = null;
        this.i18n = null;
        this.defaultContainerName = 'toasts';

        this.initContainers();

        this.modals = [];
    }

    /**
     * Initialises the containers to mount dynamic components.
     *
     * @memberOf Notifier
     */
    initContainers() {
        this.containers.toasts = this.createContainer(this.defaultContainerName);
        this.containers.modals = this.createContainer('modals');
    }

    /**
     * Create a container in DOM for mounting components
     *
     * @param {any} name
     * @returns
     *
     * @memberOf Notifier
     */
    createContainer(name) {
        const container = document.createElement('div');
        container.classList.add(name);
        document.body.appendChild(container);
        return container;
    }

    /**
     * Destroys component logic and DOM elements for any thrown component
     *
     * Used to destroy toasts, confirms, dialogs and alerts internally
     * Externally it can be used to clean up a modal containing a custom component
     *
     * @param {any} modal - The modal to destroy
     *
     * @memberOf Notifier
     */
    destroy(modal) {
        modal.hide();
        this.modals.splice(this.modals.indexOf(modal), 1);
        if (modal && modal.$el.parentElement) {
            modal.$el.parentElement.removeChild(modal.$el);
        }
        modal.$destroy();
    }

    /**
     * Install method for Vue plugin
     *
     * @param {any} Vue
     *
     * @memberOf Notifier
     */
    install(Vue) {
        /* eslint-disable vue/multi-word-component-names */
        this.components.Toast = Vue.component('Toast', Toast);
        /* eslint-enable vue/multi-word-component-names */

        Vue.prototype.$notify = this;
    }
}
